<template>
  <v-row>
    <v-col cols="12">
      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loading"
          indeterminate
        />
      </div>

      <!-- list filters -->
      <v-card>
        <v-card-title> Filtrar </v-card-title>
        <v-row class="px-2 ma-0">
          <v-col
            cols="12"
            sm="2"
          >
            <VSelect
              v-model="equipeSelecionada"
              :items="equipes"
              item-text="nome"
              item-value="id"
              label="Equipe"
              outlined
              dense
              clearable
              hide-details
              @change="handleSelecionarEquipe"
            />
          </v-col>

          <v-col
            cols="12"
            sm="3"
          >
            <VSelect
              v-model="agenteSelecionado"
              :items="agentes"
              item-text="nomeIntegrante"
              item-value="idIntegrante"
              label="Agente"
              outlined
              dense
              clearable
              hide-details
              @click="getAgentes"
              @change="search = false; equipeSelecionada = null"
            />
          </v-col>

          <v-col
            cols="12"
            md="2"
            sm="4"
          >
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  label="Período de:"
                  outlined
                  dense
                  clearable
                  hide-details
                  color="primary"
                  v-bind="attrs"
                  :rules="[validators.required]"
                  v-on="on"
                  @blur="filtroPeriodoInicio = parseDate(dateFormatted)"
                />
              </template>

              <v-date-picker
                v-model="filtroPeriodoInicio"
                no-title
                color="primary"
                locale="pt-br"
                @input="menu1 = false"
              />
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            md="2"
            sm="6"
          >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="computedDateFormatted"
                  label="Período até:"
                  outlined
                  dense
                  clearable
                  hide-details
                  v-bind="attrs"
                  :rules="[validators.required]"
                  v-on="on"
                  @blur="filtroPeriodoFim = parseDate(computedDateFormatted)"
                />
              </template>

              <v-date-picker
                v-model="filtroPeriodoFim"
                no-title
                color="primary"
                locale="pt-br"
                @input="menu2 = false"
              />
            </v-menu>
          </v-col>

          <v-spacer></v-spacer>

          <v-col
            cols="12"
            md="2"
            sm="12"
            class="text-right"
          >
            <v-btn
              color="primary"
              :loading="loadingButton"
              @click="filtrar"
            >
              <v-icon>{{ icons.mdiPlus }}</v-icon>
              <span>Filtrar</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <v-col
      v-if="(equipeSelecionada !== null || agenteSelecionado !== null) && search"
      cols="12"
      md="12"
      sm="12"
    >
      <tickets-categoria-status-contador
        :dados-tickets="contadorTicketsCategoriaStatus"
        :loading.sync="loadingComponentes"
      />
    </v-col>

    <v-col
      cols="12"
      md="12"
    >
      <v-row class="match-height">
        <v-col
          v-if="(equipeSelecionada !== null || agenteSelecionado !== null) && search"
          cols="12"
          sm="4"
        >
          <div style="min-height: 4px">
            <v-progress-linear
              v-if="loadingComponentes"
              indeterminate
            />
          </div>
          <statistics-card-vertical
            v-if="!loadingComponentes"
            :color="capacidadeAtendimentoOptions.color"
            :icon="capacidadeAtendimentoOptions.icon"
            :statistics="capacidadeAtendimento.toString()"
            :stat-title="capacidadeAtendimentoOptions.statTitle"
          />
        </v-col>

        <v-col
          v-if="equipeSelecionada !== null && search"
          cols="12"
          sm="4"
        >
          <div style="min-height: 4px">
            <v-progress-linear
              v-if="loadingComponentes"
              indeterminate
            />
          </div>
          <statistics-card-vertical
            v-if="!loadingComponentes"
            :color="mediaTicketsAgentesOptions.color"
            :icon="mediaTicketsAgentesOptions.icon"
            :statistics="mediaTicketsAgentesTotal.toString()"
            :stat-title="mediaTicketsAgentesOptions.statTitle"
          />
        </v-col>

        <v-col
          v-if="(equipeSelecionada !== null || agenteSelecionado !== null) && search"
          cols="12"
          sm="4"
        >
          <div style="min-height: 4px">
            <v-progress-linear
              v-if="loadingComponentes"
              indeterminate
            />
          </div>
          <statistics-card-vertical
            v-if="!loadingComponentes"
            :color="mediaEsperaOptions.color"
            :icon="mediaEsperaOptions.icon"
            :statistics="mediaEspera"
            :stat-title="mediaEsperaOptions.statTitle"
          />
        </v-col>

        <v-col
          v-if="(equipeSelecionada !== null || agenteSelecionado !== null) && search"
          cols="12"
        >
          <v-expand-transition>
            <tempos-medios-entre-respostas-de-agentes-card
              :tempos-medios-entre-respostas="temposMediosEntreRespostas"
              :loading="loadingComponentes"
            />
          </v-expand-transition>
        </v-col>

        <v-col
          v-if="(equipeSelecionada !== null || agenteSelecionado !== null) && search"
          cols="12"
        >
          <v-expand-transition>
            <tempos-de-primeira-resposta-apos-transbordo-card
              :tempos-de-primeiras-respostas-apos-transbordo="temposDePrimeirasRespostasAposTransbordo"
              :loading="loadingComponentes"
            />
          </v-expand-transition>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { mdiCalendar, mdiPoll } from '@mdi/js'
import { required, select } from '@core/utils/validation'
import { mapState } from 'pinia'
import TicketsCategoriaStatusContador from '@/views/dashboard/equipe/TicketsCategoriaStatusContadorEquipe.vue'
import StatisticsCardVertical from '@/@core/components/statistics-card/StatisticsCardVertical.vue'
import TemposMediosEntreRespostasDeAgentesCard from '@/views/dashboard/equipe/TemposMediosEntreRespostasDeAgentesCard.vue'
import TemposDePrimeiraRespostaAposTransbordoCard from '@/views/dashboard/equipe/TemposDePrimeiraRespostaAposTransbordoCard.vue'
import EquipeService from '@/services/modules/EquipeService'
import DashboardService from '@/services/modules/DashboardService'
import useUserStore from '@/store/user'
import useAuthStore from '@/store/auth'
import { formatTime } from '@/utils/time'
import { getDataFinalMes, getDataInicialMes } from '@/utils/dateTime'

export default {
  components: {
    TicketsCategoriaStatusContador,
    StatisticsCardVertical,
    TemposMediosEntreRespostasDeAgentesCard,
    TemposDePrimeiraRespostaAposTransbordoCard,
  },

  data: () => ({
    equipes: [],
    equipeSelecionada: null,
    agentes: [],
    agenteSelecionado: null,
    loading: true,
    loadingComponentes: true,
    search: false,
    loadingButton: false,
    capacidadeAtendimento: ref(0),
    mediaTicketsAgentesTotal: ref(0),
    mediaEspera: ref(''),
    contadorTicketsCategoriaStatus: [],
    temposMediosEntreRespostas: [],
    temposDePrimeirasRespostasAposTransbordo: [],
  }),

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
    ...mapState(useUserStore, ['id', 'isUsuario']),
  },

  mounted() {
    this.getEquipes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.acessos.idTotalCategoriaStatus)) {
        this.acessos.acessoTotalCategoriaStatus = false
      }
      if (!this.funcionalidades.includes(this.acessos.idMediaTickets)) {
        this.acessos.acessoMediaTickets = false
      }
      if (!this.funcionalidades.includes(this.acessos.idCapacidade)) {
        this.acessos.acessoCapacidade = false
      }
      if (!this.funcionalidades.includes(this.acessos.idMediaEspera)) {
        this.acessos.acessoMediaEspera = false
      }
      if (this.acessos.acessoTotalCategoriaStatus || this.acessos.acessoMediaTickets
            || this.acessos.acessoCapacidade || this.acessos.acessoMediaEspera) {
        this.acessos.acessoFiltro = true
      }
    },

    async getEquipes() {
      try {
        this.loading = true
        const integranteId = this.isUsuario ? this.id : null
        this.equipes = await EquipeService.getEquipesAtivas(integranteId)
      } finally {
        this.loading = false
      }
    },

    async getAgentes() {
      try {
        this.loading = true
        const equipeId = this.equipeSelecionada || null

        let gestorId = null
        if (!this.equipeSelecionada) gestorId = this.isUsuario ? this.id : null

        this.agentes = await EquipeService.getEquipeAgentes(equipeId, gestorId)
      } finally {
        this.loading = false
      }
    },

    async getTemposMediosEntreRespostasDeAgentes() {
      this.temposMediosEntreRespostas = await DashboardService.getTemposMediosEntreRespostasDeAgentes(this.equipeSelecionada, this.agenteSelecionado, this.filtroPeriodoInicio, this.filtroPeriodoFim)
    },

    async getTemposDePrimeirasRespostasDosAgentesAposTransbordo() {
      this.temposDePrimeirasRespostasAposTransbordo = await DashboardService.getTempoDePrimeiraRespostaAposTransbordo(this.equipeSelecionada, this.agenteSelecionado, this.filtroPeriodoInicio, this.filtroPeriodoFim)
    },

    async getParams(data) {
      const params = new URLSearchParams()

      // 1 PARA PEGAR APENAS EQUIPE OU AGENTE
      if (data === 1) {
        if (this.equipeSelecionada) { params.append('EquipeId', this.equipeSelecionada) }

        if (this.agenteSelecionado) { params.append('AgenteId', this.agenteSelecionado) }

        return params.toString()
      }

      // 2 PARA PEGAR DADOS PARA EQUIPE
      if (data === 2) {
        if (this.equipeSelecionada) { params.append('EquipeId', this.equipeSelecionada) }

        if (this.filtroPeriodoInicio) { params.append('Inicio', this.filtroPeriodoInicio) }

        if (this.filtroPeriodoFim) { params.append('Fim', this.filtroPeriodoFim) }

        return params.toString()
      }

      // NADA PARA PEGAR TUDO
      if (this.equipeSelecionada) { params.append('EquipeId', this.equipeSelecionada) }

      if (this.agenteSelecionado) { params.append('AgenteId', this.agenteSelecionado) }

      if (this.filtroPeriodoInicio) { params.append('Inicio', this.filtroPeriodoInicio) }

      if (this.filtroPeriodoFim) { params.append('Fim', this.filtroPeriodoFim) }

      return params.toString()
    },

    async getCapacidadeAtendimento() {
      this.capacidadeAtendimento = await DashboardService.getEquipeCapacidadeDeAtendimento(this.equipeSelecionada, this.agenteSelecionado)
    },

    async getMediaTicketsPorAgentes() {
      this.mediaTicketsAgentesTotal = await DashboardService.getEquipeMediaTicketsAgentes(this.equipeSelecionada, this.filtroPeriodoInicio, this.filtroPeriodoFim)
    },

    async getMediaEspera() {
      const total = await DashboardService.getEquipeMediaEspera(this.equipeSelecionada, this.agenteSelecionado, this.filtroPeriodoInicio, this.filtroPeriodoFim)

      this.mediaEspera = formatTime(total)
    },

    async getTotalTicketsCategoriaStatus() {
      this.contadorTicketsCategoriaStatus = await DashboardService.getTotalTicketsCategoriaStatus(this.equipeSelecionada, this.agenteSelecionado, this.filtroPeriodoInicio, this.filtroPeriodoFim)
    },

    async filtrar() {
      this.loadingButton = true

      if (Date.parse(this.filtroPeriodoFim) < Date.parse(this.filtroPeriodoInicio)) {
        this.$toast.warning('O periódo final deve ser menor que o periódo inicial!', {
          timeout: false,
        })
        this.loadingButton = false

        return
      }

      const diferenca = Date.parse(this.filtroPeriodoFim) - Date.parse(this.filtroPeriodoInicio)
      const diferencaDias = diferenca / (1000 * 3600 * 24)
      if (diferencaDias >= 366) {
        this.$toast.warning('A diferença entre as datas deve ser de no máximo 365 dias!', {
          timeout: false,
        })
        this.loadingButton = false

        return
      }

      this.search = true
      this.loadingComponentes = true

      if (this.equipeSelecionada || this.agenteSelecionado) {
        await this.getCapacidadeAtendimento()
        await this.getMediaEspera()
        await this.getTotalTicketsCategoriaStatus()
        await this.getTemposMediosEntreRespostasDeAgentes()
        await this.getTemposDePrimeirasRespostasDosAgentesAposTransbordo()
      }

      if (this.equipeSelecionada) {
        await this.getMediaTicketsPorAgentes()
      }

      this.loadingComponentes = false
      this.loadingButton = false
    },

    handleSelecionarEquipe() {
      this.search = false
      this.agenteSelecionado = null
    },
  },

  setup() {
    const filtroPeriodoInicio = ref(getDataInicialMes())
    const filtroPeriodoFim = ref(getDataFinalMes())
    const menu1 = ref(false)
    const menu2 = ref(false)

    const formatDate = dates => {
      if (!dates) return null
      const [year, month, day] = dates.split('-')

      return `${day}/${month}/${year}`
    }

    const parseDate = dates => {
      if (!dates) return null
      const [day, month, year] = dates.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    let dateFormatted = computed(() => formatDate(filtroPeriodoInicio.value))
    let computedDateFormatted = computed(() => formatDate(filtroPeriodoFim.value))

    watch(filtroPeriodoInicio, () => {
      dateFormatted = formatDate(filtroPeriodoInicio.value)
    })

    watch(filtroPeriodoFim, () => {
      computedDateFormatted = formatDate(filtroPeriodoFim.value)
    })

    const capacidadeAtendimentoOptions = {
      statTitle: 'Capacidade atendimento',
      icon: mdiPoll,
      color: 'secondary',
    }

    const mediaTicketsAgentesOptions = {
      statTitle: 'Média tickets por agentes',
      icon: mdiPoll,
      color: 'secondary',
    }

    const mediaEsperaOptions = {
      statTitle: 'Média de espera',
      icon: mdiPoll,
      color: 'secondary',
    }

    return {
      filtroPeriodoFim,
      filtroPeriodoInicio,
      dateFormatted,
      menu1,
      menu2,
      computedDateFormatted,
      capacidadeAtendimentoOptions,
      mediaTicketsAgentesOptions,
      mediaEsperaOptions,
      parseDate,
      formatDate,
      icons: { mdiCalendar },
      validators: {
        required,
        select,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
